import {
  cardapioApi,
  clienteApi,
  refeicaoApi,
  receitaApi,
  refeicaoReceitaApi,
} from "../../services/Api";

const error = (msg) => alert(`Erro na impressão. ${msg}`);

export const getPrintData = async (cardapioId) => {
  const cardapioResponse = await cardapioApi.getOne(cardapioId);
  if (!cardapioResponse.ok) return error();
  const cardapio = cardapioResponse.data;
  const clienteResponse = await clienteApi.getOne(cardapio.clienteId);
  const refeicoesResponse = await refeicaoApi.getList(cardapioId);
  if (!clienteResponse.ok || !refeicoesResponse.ok) return error();
  const cliente = clienteResponse.data;
  const promises = refeicoesResponse.data.map(async (refeicao) => {
    const refeicaoReceitaResponse = await refeicaoReceitaApi.getList({
      where: { refeicaoId: refeicao.id },
    });
    const promises = refeicaoReceitaResponse.data.map(
      async (refeicaoReceita) => {
        const response = await receitaApi.getOne(refeicaoReceita.receitaId);
        return response.data;
      }
    );
    const receitas = await Promise.all(promises);
    return {
      ...refeicao,
      receitas,
    };
  });
  const refeicoes = await Promise.all(promises);

  return {
    cliente,
    refeicoes,
    cardapio,
  };
};
